// import { Link } from "react-router-dom";
// import { useState } from "react";

// const Navbar = () => {

//   const [showServices, setShowServices] = useState(false);
//   const [showDGFT, setShowDGFT] = useState(false);
//   const [showSubsidy, setShowSubsidy] = useState(false);

//   return (
//     <nav className="navbar">

//       <h2 className="logo">MyCompany</h2>

//       <ul className="menu">

//         <li><Link to="/">Home</Link></li>

//         <li><Link to="/about">About</Link></li>

//         {/* MAIN DROPDOWN */}
//         <li
//           className="dropdown-parent"
//           onMouseEnter={() => setShowServices(true)}
//           onMouseLeave={() => {
//             setShowServices(false);
//             setShowDGFT(false);
//             setShowSubsidy(false);
//           }}
//         >

//           Services ▾

//           {showServices && (

//             <ul className="dropdown">

//               {/* DGFT SUBMENU */}
//               <li
//                 className="sub-parent"
//                 onMouseEnter={() => setShowDGFT(true)}
//                 onMouseLeave={() => setShowDGFT(false)}
//               >
//                 DGFT Services ▸

//                 {showDGFT && (
//                   <ul className="sub-dropdown">
//                     <li><Link to="/dgft/iec">IEC Registration</Link></li>
//                     <li><Link to="/dgft/license">Export License</Link></li>
//                   </ul>
//                 )}
//               </li>

//               {/* SUBSIDY SUBMENU */}
//               <li
//                 className="sub-parent"
//                 onMouseEnter={() => setShowSubsidy(true)}
//                 onMouseLeave={() => setShowSubsidy(false)}
//               >
//                 Subsidy Services ▸

//                 {showSubsidy && (
//                   <ul className="sub-dropdown">
//                     <li><Link to="/subsidy/state">State Subsidy</Link></li>
//                     <li><Link to="/subsidy/central">Central Subsidy</Link></li>
//                   </ul>
//                 )}
//               </li>

//               {/* NORMAL ITEM */}
//               <li><Link to="/consulting">Consulting</Link></li>

//             </ul>

//           )}

//         </li>

//         <li><Link to="/contact">Contact</Link></li>

//       </ul>

//     </nav>
//   );
// };

// export default Navbar;

import { useState } from "react";
import menuData from "../data/menuData";
import MenuItem from "../pages/MenuItem";
import { Link } from "react-router-dom";
import logo from "../assets/WhatsApp Image 2026-02-11 at 6.38.15 PM.jpeg";
import { FaPhone } from "react-icons/fa";
// import { NavLink, useLocation } from "react-router-dom";


const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    // <nav className="navbar container">
      
    //   {/* LEFT → LOGO */}
    //   <div className="logo">
    //     <Link to="/">
    //       <img className="company-logo" src={logo} alt="APEX Consultants" />
    //     </Link>
    //   </div>

    //   {/* RIGHT SECTION */}
    //   <div className="right-section">

    //     {/* TOP → CONTACT INFO */}
    //     <div className="top-bar">
    //       <span>📧 veera@apexconsultants.in</span>

    //       <span>📞 +91 72077 57511</span>
    //     </div>

    //     {/* HAMBURGER (MOBILE) */}
    //     <div className="hamburger" onClick={() => setOpen(!open)}>
    //       ☰
    //     </div>

    //     {/* BOTTOM → MENU */}
    //     <ol className={`menu ${open ? "active" : ""}`}>
    //       {menuData.map((item, index) => (
    //         <MenuItem key={index} item={item} />
    //       ))}
    //     </ol>

    //   </div>

    // </nav>

    <nav className="navbar container">

  {/* LEFT → LOGO + HAMBURGER */}
  <div className="logo-section">
    
    <div className="hamburger" onClick={() => setOpen(!open)}>
      ☰
    </div>

    <Link to="/">
      <img className="company-logo" src={logo} alt="APEX Consultants" />
    </Link>

  </div>

  {/* RIGHT SECTION */}
  <div className="right-section">

    <div className="top-bar">
          <span>📧 info@apexconsultants.in</span>
          {/* <span className="contact-item">
             <FaEnvelope className="icon rotate-icon" />
    veera@apexconsultants.in
   
  </span> */}
      {/* <span>📞 +91 72077 57511</span> */}
      <span>
  <FaPhone className="phone-icon rotate-icon" />
  +91 72077 57511
</span>
    </div>

    <ol className={`menu ${open ? "active" : ""}`}>
      {menuData.map((item, index) => (
        <MenuItem  key={index} 
  item={item} 
  closeMenu={() => setOpen(false)}  />
      ))}
    </ol>

  </div>

</nav>
  );
};

export default Navbar;


// import { useState } from "react";
// import menuData from "../data/menuData";
// import MenuItem from "../pages/MenuItem";
// import { Link } from "react-router-dom";
// import logo from "../assets/WhatsApp Image 2026-02-11 at 6.38.15 PM.jpeg";

// const Navbar = () => {
//   const [open, setOpen] = useState(false);

//   return (
//     <nav className="navbar container align-items-center">

//       {/* LOGO */}
//       <div className="logo">
//         <Link to="/">
//           <img className="company-logo" src={logo} alt="APEX Consultants" />
//         </Link>
//       </div>

//       {/* HAMBURGER (ONLY MOBILE) */}
//       <div className="hamburger" onClick={() => setOpen(!open)}>
//         ☰
//       </div>

//       {/* MENU */}
//       <ol className={`menu ${open ? "active" : ""}`}>
//         {menuData.map((item, index) => (
//           <MenuItem key={index} item={item} />
//         ))}
//       </ol>

//     </nav>
//   );
// };

// export default Navbar;







